module.exports = __webpack_public_path__ + "img/solution_3.ed272d78.png";